import { ToastContainer, toast, type Theme } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/** Reads the resolved theme without needing React context. Checks the `.dark` class on <html> (kept in sync by useDarkMode for all modes — system/light/dark) rather than localStorage directly, so this stays correct in `system` mode too.
 * class on <html> (kept in sync by useDarkMode for all modes — system/light/dark)
 * rather than localStorage directly, so this stays correct in `system` mode too.
 */
const getToastTheme = (): Theme => {
  try {
    return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

export function CtyToast() {
  return (
    <ToastContainer theme={getToastTheme()} />
  );
}

export const checkType = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};

export const CtyShowToast = (type: string, message: string) => {
  const baseOptions = {
    position: "top-center" as const,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: getToastTheme(),
  };
  if (type === checkType.success) {
    toast.success(message, baseOptions);
  }
  else if (type === checkType.warning) {
    toast.warn(message, baseOptions);
  }
  else if (type === checkType.error) {
    toast.error(message, baseOptions);
  }
  else if (type === checkType.info) {
    toast.info(message, baseOptions);
  }
}

export default CtyToast;
